import { SupabaseClient } from "@supabase/supabase-js";
import { startOfDay, endOfDay } from "date-fns";

export const fetchLosses = async (
  supabase: SupabaseClient,
  periodStart: Date | null
) => {
  let query = supabase
    .from('stock_losses')
    .select(`
      *,
      stock_items (
        data,
        stock_id
      )
    `)
    .order('created_at', { ascending: false });

  if (periodStart) {
    query = query.gte('created_at', periodStart.toISOString());
    if (periodStart === startOfDay(new Date())) {
      query = query.lte('created_at', endOfDay(new Date()).toISOString());
    }
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching losses:', error);
    throw error;
  }

  console.log('Fetched losses:', data);

  return data.map(loss => ({
    id: loss.id,
    transaction_type: 'loss',
    stock_item_id: loss.stock_item_id,
    quantity: loss.quantity,
    unit_price: 0,
    total_amount: 0,
    transaction_date: loss.created_at,
    notes: loss.reason,
    created_at: loss.created_at,
    created_by: loss.created_by,
    stock_items: loss.stock_items,
    proof_url: loss.proof_url,
    is_restocked: loss.is_restocked,
    restocked_at: loss.restocked_at,
    restocked_by: loss.restocked_by,
    digital_signature: null
  }));
};